module.exports = __webpack_public_path__ + "static/img/code.89d104e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.jpg
// module id = GwFP
// module chunks = 8